export default __webpack_public_path__ + "static/media/lacak.18b85f45.png";